import UpdateTransporter from "../../../components/@logistics/UpdateTransporter";

import { routeTypes } from "../../../hooks/useSystemRoutes";

export default function TransporterUpdatePage() {

    return (
        <UpdateTransporter 
            routeType={routeTypes.admin}
        />
    )
}       